export const api = {
    login: '/auth/login',
    userMe: '/auth/me',
    registerUser: '/auth/register',
    bank: '/bank',
};